/* assets/component-card-switcher.js */

document.addEventListener('click', function(e) {
  // Sprawdź czy kliknięto w nasz przycisk wariantu
  const btn = e.target.closest('.cvs-btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  // Jeśli przycisk jest już aktywny, nic nie rób
  if (btn.classList.contains('active')) return;

  // Znajdź główny kontener karty produktu
  const card = btn.closest('hdt-card-product');
  if (!card) return;

  // --- POBIERANIE DANYCH Z PRZYCISKU ---
  const data = {
    id: btn.dataset.id,
    title: btn.dataset.title,
    url: btn.dataset.url,
    img: btn.dataset.img,
    imgHover: btn.dataset.imgHover,
    price: btn.dataset.price,
    comparePrice: btn.dataset.comparePrice
  };

  // --- ZMIANA STANU PRZYCISKÓW (UI) ---
  const wrapper = btn.closest('.card-variant-switcher');
  wrapper.querySelectorAll('.cvs-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // --- ANIMACJA (Opacity) ---
  const elementsToAnimate = [
    card.querySelector('.hdt-card-product__media'),
    card.querySelector('.hdt-card-product__title'),
    card.querySelector('.hdt-price-wrapp')
  ].filter(el => el); // filtrujemy null, jeśli czegoś nie znajdzie

  elementsToAnimate.forEach(el => el.classList.add('cvs-updating'));

  // Krótkie opóźnienie dla efektu wizualnego
  setTimeout(() => {
    
    // 1. PODMIANA ID DO KOSZYKA (Najważniejsze)
    // Szukamy formularza i inputu name="id"
    const form = card.querySelector('form[action*="/cart/add"]');
    if (form) {
      const inputId = form.querySelector('input[name="id"]');
      if (inputId) inputId.value = data.id;
      
      // Niektóre szablony mają też ukryty input name="product-id"
      const inputProdId = form.querySelector('input[name="product-id"]');
      if (inputProdId) inputProdId.value = data.id; // Tutaj teoretycznie powinno być Product ID, ale Variant ID często też działa w Shopify, zależnie od logiki theme'u. 
      // W Shopify 'id' w formularzu to ZAWSZE Variant ID.
    }

    // 2. PODMIANA OBRAZKA
    if (data.img) {
      const mainImg = card.querySelector('.hdt-card-product__media--main');
      if (mainImg) {
        mainImg.src = data.img;
        mainImg.srcset = data.img; // Resetujemy srcset, żeby przeglądarka nie wymusiła starego
      }
    }
    // Podmiana hovera (opcjonalnie, jeśli jest w danych)
    if (data.imgHover) {
      const hoverImg = card.querySelector('.hdt-card-product__media--hover');
      if (hoverImg) {
        hoverImg.src = data.imgHover;
        hoverImg.srcset = data.imgHover;
      }
    }

    // 3. PODMIANA TYTUŁU I LINKÓW
    const titleEl = card.querySelector('.hdt-card-product__title');
    if (titleEl) {
      titleEl.textContent = data.title;
      titleEl.href = data.url;
    }
    // Podmieniamy też link na obrazku
    const imgLink = card.querySelector('.hdt-card-product__media-wrapp');
    if (imgLink) imgLink.href = data.url;

    // 4. PODMIANA CENY
    const priceEl = card.querySelector('.hdt-price .hdt-money');
    if (priceEl) priceEl.innerHTML = data.price;

    const comparePriceEl = card.querySelector('.hdt-compare-at-price .hdt-money');
    const compareWrapper = card.querySelector('.hdt-compare-at-price');
    
    if (data.comparePrice) {
      // Jeśli jest cena promocyjna
      if (comparePriceEl) comparePriceEl.innerHTML = data.comparePrice;
      if (compareWrapper) compareWrapper.classList.remove('hdt-hidden');
    } else {
      // Jeśli nie ma promocji, ukrywamy przekreśloną cenę
      if (compareWrapper) compareWrapper.classList.add('hdt-hidden');
    }

    // KONIEC ANIMACJI
    elementsToAnimate.forEach(el => el.classList.remove('cvs-updating'));

  }, 200);
});